

import React, { useState } from "react";
import axios from "axios";

import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaClock,
} from "react-icons/fa";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Header from "../General/Header";
import Footer from "./Footer";

const Contact = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });


  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

  };

  const handleSubmit = async (e) => {

  e.preventDefault();

 
  if (
    !form.name ||
    !form.email ||
    !form.message
  ) {

    toast.error("Please fill all required fields");

    return;

  }

  try {

    const response = await axios.post(
      "https://api.statixtrading.in/api/api/contact",
      form
    );

    toast.success(response.data.message);

    setForm({
      name: "",
      email: "",
      message: "",
    });

  } catch (error) {

    console.log(error);

    toast.error(
      error.response?.data?.message ||
      "Something went wrong"
    );

  }

};

  return (
    <>
      <Header />


 <ToastContainer
      position="top-center"
      autoClose={3000}
    />

      <div
        style={{
          background: "#0f172a",
          color: "#fff",
          minHeight: "100vh",
        }}
      >

        <section
          style={{
            padding: "90px 20px",
            textAlign: "center",
            background:
              "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #111827 100%)",
          }}
        >
          <h1
            style={{
              fontSize: "55px",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            Contact Us
          </h1>

          <p
            style={{
              maxWidth: "750px",
              margin: "auto",
              color: "#cbd5e1",
              fontSize: "20px",
              lineHeight: "34px",
            }}
          >
            Have questions about trading, accounts, or support? Our team is
            available 24/7 to help you.
          </p>
        </section>

    
        <section
          style={{
            padding: "80px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "auto",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "40px",
            }}
          >
            {/* Left Side */}
            <div
              style={{
                background: "#1e293b",
                padding: "40px",
                borderRadius: "20px",
              }}
            >
              <h2
                style={{
                  fontSize: "38px",
                  marginBottom: "30px",
                }}
              >
                Get In Touch
              </h2>

              <div style={{ marginBottom: "30px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                  }}
                >
                  <FaEnvelope size={22} color="#22c55e" />

                  <h3>Email</h3>
                </div>

                <p
                  style={{
                    color: "#cbd5e1",
                    marginTop: "10px",
                    paddingLeft: "38px",
                  }}
                >
                  support@tradingplatform.com
                </p>
              </div>

              <div style={{ marginBottom: "30px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                  }}
                >
                  <FaPhoneAlt size={22} color="#22c55e" />

                  <h3>Phone</h3>
                </div>

                <p
                  style={{
                    color: "#cbd5e1",
                    marginTop: "10px",
                    paddingLeft: "38px",
                  }}
                >
                  +91 9876543210
                </p>
              </div>

              <div style={{ marginBottom: "30px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                  }}
                >
                  <FaMapMarkerAlt size={22} color="#22c55e" />

                  <h3>Address</h3>
                </div>

                <p
                  style={{
                    color: "#cbd5e1",
                    marginTop: "10px",
                    paddingLeft: "38px",
                    lineHeight: "28px",
                  }}
                >
                  123 Business Street,
                  <br />
                  New Delhi, India
                </p>
              </div>

              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                  }}
                >
                  <FaClock size={22} color="#22c55e" />

                  <h3>Working Hours</h3>
                </div>

                <p
                  style={{
                    color: "#cbd5e1",
                    marginTop: "10px",
                    paddingLeft: "38px",
                  }}
                >
                  24/7 Customer Support
                </p>
              </div>
            </div>

            <div
              style={{
                background: "#1e293b",
                padding: "40px",
                borderRadius: "20px",
              }}
            >
              <h2
                style={{
                  fontSize: "38px",
                  marginBottom: "30px",
                }}
              >
                Send Message
              </h2>

              <form onSubmit={handleSubmit}>

                <div style={{ marginBottom: "20px" }}>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    style={{
                      width: "100%",
                      padding: "15px",
                      borderRadius: "10px",
                      border: "none",
                      outline: "none",
                      background: "#0f172a",
                      color: "#fff",
                      fontSize: "16px",
                    }}
                  />
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="Your Email"
                    style={{
                      width: "100%",
                      padding: "15px",
                      borderRadius: "10px",
                      border: "none",
                      outline: "none",
                      background: "#0f172a",
                      color: "#fff",
                      fontSize: "16px",
                    }}
                  />
                </div>

                <div style={{ marginBottom: "20px" }}>
                  <textarea
                    rows="6"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Write Your Message..."
                    style={{
                      width: "100%",
                      padding: "15px",
                      borderRadius: "10px",
                      border: "none",
                      outline: "none",
                      background: "#0f172a",
                      color: "#fff",
                      fontSize: "16px",
                      resize: "none",
                    }}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  style={{
                    width: "100%",
                    padding: "15px",
                    background: "#22c55e",
                    border: "none",
                    borderRadius: "10px",
                    color: "#fff",
                    fontSize: "18px",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  Send Message
                </button>

              </form>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section
          style={{
            padding: "0 20px 80px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "auto",
              borderRadius: "20px",
              overflow: "hidden",
            }}
          >
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224346.48198781043!2d76.76357583392496!3d28.643684617819987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d047309fff9cf%3A0xf5f1b7e7d7f7916f!2sNew%20Delhi!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin"
              width="100%"
              height="400"
              style={{
                border: "0",
              }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </section>
      </div>
      <Footer/>
    </>
  );
};

export default Contact;